import { Link } from "react-router-dom";
import { mergeClass } from "../../utils";
import { Button } from "../Button";
import { Spinner } from "../Loader";

export const Banner = ({
  published,
  handlePublishPressed,
  isPublishing,
  endpointUrl,
}: {
  published: boolean | undefined;
  isPublishing: boolean;
  handlePublishPressed: () => void;
  endpointUrl?: string;
}): JSX.Element => (
  <div
    className={mergeClass(
      "w-full pl-4 pr-2 py-2 mb-3 font-medium rounded-sm text-white flex justify-between",
      {
        "bg-grayBg": published === false,
        "bg-successGreen": published === true,
      }
    )}
  >
    <div className="place-self-center">
      {published ? "Content is up to date" : "There are unpublished changes"}
    </div>
    <div className="flex gap-1 text-sm">
      <Button
        onClick={() => handlePublishPressed()}
        className={mergeClass("py-1.5", {
          "bg-successGreen border-successGreen": !published,
          "bg-grayBg border-grayBg": published,
        })}
        disabled={isPublishing}
        title="Update published data"
      >
        <div className="flex gap-2">
          Publish
          {isPublishing && <Spinner />}
        </div>
      </Button>
      {endpointUrl && (
        <Link to={endpointUrl} target="_blank" title="View published data">
          <Button
            className={mergeClass("py-1.5", {
              "bg-successGreen border-successGreen": !published,
              "bg-grayBg border-grayBg": published,
            })}
          >
            View data
          </Button>
        </Link>
      )}
    </div>
  </div>
);
